'use strict';

var index = require('../../../../../aviary-tokens/dist/cjs/index.cjs');
var isLocalStorageEnabled = require('./isLocalStorageEnabled.cjs');

/**
 * Returns the theme based on the brand, controlled theme, and preferred color scheme
 */ const getTheme = (brand, controlledTheme, isPrefersDark, isDS3, screenSize)=>{
    if (brand === "emerson") return index.emersonWeb[screenSize];
    if (isDS3) return index.fullscriptWebDs3;
    if (controlledTheme) return controlledTheme === "dark" ? index.fullscriptWebDark[screenSize] : index.fullscriptWebLight[screenSize];
    const localStorageTheme = isLocalStorageEnabled.isLocalStorageEnabled() ? localStorage.getItem("aviaryTheme") : null;
    if (localStorageTheme === "dark" || isPrefersDark && !localStorageTheme) {
        return index.fullscriptWebDark[screenSize];
    }
    return index.fullscriptWebLight[screenSize];
};

exports.getTheme = getTheme;
//# sourceMappingURL=getTheme.cjs.map
